import React from 'react';
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Layout from '../../components/Layout'
import ProgressBar from '../../components/ProgressBar'
import ButtonComponent from '../../components/Button';

import howtoidcard from '../../assets/images/howtoidcard.svg'

import constants from '../../config/constants'

const Main = styled.div`
  padding: 2rem 0;
  overflow-y: scroll;
  scroll-behavior: smooth;
`

const MainImg  = styled.div`
  padding: 2rem 0;
  text-align: center;
`

const HowToIDCard = (props) => {

  return (
    <Layout title={'รูปบัตรประชาชน'} backIcon={true} onClick={() => props.history.goBack()}>
      <ProgressBar percent={50}/>
      <Main>
        <h5>กรุณาถ่ายรูปบัตรประชาชนด้วยโทรศัพท์มือถือของคุณ โดยต้องสามารถอ่านและเห็นรายละเอียดบนบัตรได้อย่างชัดเจน </h5>
        <MainImg>
          <LazyLoadImage
            alt=''
            height={220}
            visibleByDefault={true}
            src={howtoidcard}
            width={'auto'} />
        </MainImg>
      </Main>
      <ButtonComponent
        textcolor={constants.color.white}
        bordercolor={constants.color.orange}
        backgroundcolor={constants.color.orange}
        text={'ถ่ายรูป'}
        disabled={false}
        onClick={() => props.history.push('/camera-id-card')}/>
    </Layout>
  )
}

export default HowToIDCard
